import React from 'react';
import { Box, Typography } from '@mui/material';

const UnsubscribeBlock = ({ 
  data, 
  isSelected, 
  previewMode, 
  onUpdate,
  isReadOnly = false 
}) => {
  const {
    text = "You are receiving this email because you subscribed to our newsletter. If you wish to unsubscribe, please click the button below.",
    buttonText = "Unsubscribe",
    textColor = '#666666',
    buttonColor = '#dc3545',
    buttonTextColor = '#ffffff',
    fontSize = 12,
    textAlign = 'center',
    marginTop = 30,
    marginBottom = 20,
    padding = 20,
    backgroundColor = '#f8f9fa',
    borderRadius = 4,
  } = data;

  const containerStyle = {
    backgroundColor,
    borderRadius: `${borderRadius}px`,
    padding: `${padding}px`,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    textAlign,
    border: isReadOnly ? '2px solid #ffc107' : (isSelected ? '2px solid #007bff' : '1px solid #e0e0e0'),
    position: 'relative',
  };

  const textStyle = {
    color: textColor,
    fontSize: `${fontSize}px`,
    lineHeight: 1.5,
    marginBottom: '15px',
  };

  const buttonStyle = {
    backgroundColor: buttonColor,
    color: buttonTextColor,
    padding: '10px 20px',
    borderRadius: '4px',
    textDecoration: 'none',
    display: 'inline-block',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
  };

  return (
    <Box sx={containerStyle}>
      {isReadOnly && (
        <Box
          sx={{
            position: 'absolute',
            top: -8,
            left: 8,
            backgroundColor: '#ffc107',
            color: '#000',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '10px',
            fontWeight: 'bold',
            zIndex: 1,
          }}
        >
          PROTECTED
        </Box>
      )}
      
      <Typography sx={textStyle}>
        {text}
      </Typography>
      
      <a 
        href="{{unsubscribe_url}}" 
        style={buttonStyle}
        onClick={(e) => {
          e.preventDefault(); // Предотвращаем переход в редакторе
          // Не блокируем stopPropagation чтобы можно было выбрать блок
        }}
      >
        {buttonText}
      </a>
      
      <Typography
        sx={{
          fontSize: '10px',
          color: '#999',
          marginTop: '10px',
          fontStyle: 'italic',
        }}
      >
        This unsubscribe link will be automatically generated when the email is sent.
      </Typography>
    </Box>
  );
};

export default UnsubscribeBlock; 